export default "__VITE_ASSET__lxobhwBD__"